module.exports = __webpack_public_path__ + "img/thumb-briesoep.48836f5d.jpeg";